import { useState } from "react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { Products } from "@/components/Products";
import { Industries } from "@/components/Industries";
import { Capabilities } from "@/components/Capabilities";
import { MachineShowcase } from "@/components/MachineShowcase";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [prefill, setPrefill] = useState(null);
  return (
    <div data-testid="home-page" className="bg-[#F5F1EA] min-h-screen">
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Products onEnquire={setPrefill} />
        <Industries />
        <Capabilities />
        <MachineShowcase />
        <QuoteForm prefill={prefill} />
      </main>
      <Footer />
    </div>
  );
}
